import InternalNavbar from "./InternalNavbar";
export default InternalNavbar;
